import { render } from "./GoTopButton.vue?vue&type=template&id=441e9cc4&scoped=true"
import script from "./GoTopButton.vue?vue&type=script&lang=js"
export * from "./GoTopButton.vue?vue&type=script&lang=js"

import "./GoTopButton.vue?vue&type=style&index=0&id=441e9cc4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441e9cc4"]])

export default __exports__